/**
 * Sentry initialization for the web frontend. Imported FIRST in main.tsx so
 * Sentry's instrumentation can patch fetch/router before they're used.
 *
 * No-op when VITE_SENTRY_DSN is unset (local dev) or NODE_ENV !== 'production'.
 *
 * Source-map upload is configured via @sentry/vite-plugin in vite.config.ts;
 * uploads only run when SENTRY_AUTH_TOKEN is set in the build environment.
 */
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

Sentry.init({
  dsn,
  environment: import.meta.env.MODE,
  enabled: !!dsn && import.meta.env.PROD,
  // Performance tracing disabled for now — keeps free-tier event budget for
  // actual errors. Enable later by raising tracesSampleRate to 0.05–0.1.
  tracesSampleRate: 0,
  // Filter dev-only errors that leak through if a DSN is set in non-prod.
  beforeSend(event) {
    if (!import.meta.env.PROD) return null;
    return event;
  },
});

export { Sentry };
